/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pos_Einvoice_Auto_PublishingInputs */

const vi_pos_einvoice_auto_publishing = /** @type {(inputs: Pos_Einvoice_Auto_PublishingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Đang tự phát hành hóa đơn lên MISA…`)
};

/**

* @param {Pos_Einvoice_Auto_PublishingInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const pos_einvoice_auto_publishing = /** @type {((inputs?: Pos_Einvoice_Auto_PublishingInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pos_Einvoice_Auto_PublishingInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_pos_einvoice_auto_publishing(inputs)
});